// frontend/src/components/Automations/AutomationsWorkspace.jsx
// Top-level Automations workspace. Sub-nav: Scheduled / Automations / Connections (MCP).
// Mirrors WholesaleWorkspace: uses the shared WorkspaceOverlay shell primitive.
import React, { useState, useEffect } from 'react';
import WorkspaceOverlay from '../shared/WorkspaceOverlay.jsx';
import ScheduledView from './ScheduledView.jsx';
import AutomationsManager from './AutomationsManager.jsx';
import McpServersPanel from '../SettingsPanel/McpServersPanel.jsx';
import './automations.css';

const TABS = [
  { key: 'scheduled',    label: 'Scheduled' },
  { key: 'automations',  label: 'Automations' },
  { key: 'connections',  label: 'Connections (MCP)' },
];

export default function AutomationsWorkspace({ isOpen, onClose, initialTab = null, initialAutomationId = null, onConsumeInitialAutomationId = null }) {
  const [tab, setTab] = useState(initialTab || 'scheduled');
  // Deep-link, mirroring SettingsPanel's `initialSection`. The capability map's
  // unhealthy-MCP repair row targets this workspace because McpServersPanel
  // lives under the `connections` tab — but landing on the DEFAULT tab made
  // that a two-click repair, and the row's promise ("opens Connections") was
  // only true of the panel, not of what the operator saw. Assigns
  // unconditionally, including null, so a plain open never inherits a stale tab.
  useEffect(() => {
    if (isOpen) setTab(initialTab || 'scheduled');
  }, [isOpen, initialTab]);
  return (
    <WorkspaceOverlay
      open={isOpen}
      title="Automations"
      onClose={onClose}
      ariaLabel="Automations workspace"
      className="automations-workspace glass-panel"
      backdrop={false}   /* docked drawer — chat stays visible beside it, no dimming scrim */
    >
      <nav className="automations-ws-nav">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`ws-nav-btn${tab === t.key ? ' active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <div className="automations-ws-body">
        {tab === 'scheduled'   && <ScheduledView />}
        {tab === 'automations' && <AutomationsManager initialAutomationId={initialAutomationId} onConsumeInitialAutomationId={onConsumeInitialAutomationId} />}
        {tab === 'connections' && <McpServersPanel />}
      </div>
    </WorkspaceOverlay>
  );
}
